module.exports = __webpack_public_path__ + "static/media/HO.ebed3403.svg";